import {SearchSystem} from '@service/enum/consent-enum';

export class SearchModel {
    dob: string;
    dateOfBirth: Date;
    last4SSN: string;
    email: string;
    zipCode: string;
    lastName: string;
    productType: string;
    productName: string;
    offerCode: string;
    code: string;
    authorizedCode: string;
    encryptedKey: string;
    virtualFingerPrint: string;
    ssn: string;
    primaryPhone: string;
    memberNumber: string;
    selectedProduct: any;
    additionalDetails: any;
    searchSystem: SearchSystem;
    codeChallenger: string;
}
